import LocalStorage from '@/utils/helpers/LocalStorage'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const storage = new LocalStorage()

interface ThemeState {
	dark: boolean
}

const initialState: ThemeState = {
	dark: storage?.get('dark') ? storage?.get('dark') === 'true' : true,
}

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		toggleDarkAndLight: (
			state,
			{ payload: { dark } }: PayloadAction<{ dark: boolean }>
		) => {
			state.dark = dark
		},
	},
})

export const themeCreators = themeSlice.actions

export const themeReducer = themeSlice.reducer
